import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const UrlIcon = (props: SvgProps) => (
  <Svg
    width={17}
    height={17}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M10.911 2.013c.271-.278.593-.498.946-.648a2.856 2.856 0 0 1 2.232 0c.354.15.675.37.946.648.27.277.485.606.632.968a3.05 3.05 0 0 1 0 2.286 2.992 2.992 0 0 1-.632.969l-2.687 2.75a2.91 2.91 0 0 1-1.027.681 2.853 2.853 0 0 1-2.388-.146 2.933 2.933 0 0 1-.94-.802.547.547 0 0 0-.78-.096.58.58 0 0 0-.093.8 4.05 4.05 0 0 0 1.298 1.106 3.953 3.953 0 0 0 3.297.202 4.019 4.019 0 0 0 1.418-.94l2.688-2.751c.374-.383.67-.838.873-1.338a4.211 4.211 0 0 0 0-3.156 4.133 4.133 0 0 0-.873-1.338 4.022 4.022 0 0 0-1.307-.894 3.944 3.944 0 0 0-3.082 0 4.022 4.022 0 0 0-1.306.894L7.904 3.484a.576.576 0 0 0 .006.797.549.549 0 0 0 .78.007l2.221-2.275Z"
    />
    <Path
      fill="#000"
      d="M4.652 8.013a2.91 2.91 0 0 1 1.027-.68 2.853 2.853 0 0 1 2.388.146c.365.197.685.47.94.802a.56.56 0 0 0 .371.213.543.543 0 0 0 .41-.118.566.566 0 0 0 .208-.38.583.583 0 0 0-.115-.42 4.05 4.05 0 0 0-1.299-1.105 3.954 3.954 0 0 0-3.297-.202 4.018 4.018 0 0 0-1.418.94L1.179 9.96c-.374.383-.67.838-.872 1.338a4.21 4.21 0 0 0 0 3.156c.202.5.498.955.872 1.338.374.383.818.687 1.307.894a3.945 3.945 0 0 0 3.081 0 4.021 4.021 0 0 0 1.307-.894l2.222-2.275a.569.569 0 0 0 .177-.407.58.58 0 0 0-.163-.412.555.555 0 0 0-.403-.167.545.545 0 0 0-.396.181l-2.222 2.276c-.271.277-.593.497-.946.647a2.858 2.858 0 0 1-3.178-.647 2.991 2.991 0 0 1-.632-.97 3.049 3.049 0 0 1-.222-1.142c0-.792.307-1.552.854-2.112l2.687-2.75Z"
    />
  </Svg>
)
export default UrlIcon
